import clsx from 'clsx';
import { marked } from 'marked';
import React, { useCallback } from 'react';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Tooltip = _ref => {
  let {
    placement,
    content = '',
    className = '',
    tooltipClassName = '',
    allowEventPropagation = false,
    children
  } = _ref;
  const htmlContent = marked.parseInline(content); // Prevent tooltip clicks
  // from propagating to parent labels
  // and interacting with form fields

  const stopPropagation = useCallback(evt => {
    if (allowEventPropagation) return;

    if (evt) {
      evt.stopPropagation();
      evt.preventDefault();
    }
  }, [allowEventPropagation]);
  return /*#__PURE__*/_jsxs("span", {
    className: clsx(styles.container, ...className.split(' ')),
    tabIndex: -1,
    onClick: stopPropagation,
    children: [children, /*#__PURE__*/_jsx("span", {
      className: clsx(styles.tooltip, styles[`tooltip--${placement}`], tooltipClassName),
      dangerouslySetInnerHTML: {
        __html: htmlContent
      }
    })]
  });
};

export default Tooltip;